import { Icon, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';
import { numberHelper } from '../../utils/numberHelper';
import { CardHeaderTitle } from './CardHeaderTitle';
import { formatDateToMMDDYYYY } from '../../utils/formatters';
import { getAmountDue } from '../../state/helpers';

export const CardHeader = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  const [paymentInfo] = useGlobalState('paymentInfo');
  const [priceCart] = useGlobalState('priceCart');
  const { hasPaymentInTransit, paymentInTransitDetails } = membershipDetails;

  const amountDue = getAmountDue(membershipDetails, paymentInfo?.monthlyPaymentData, priceCart);

  return (
    <Stack
      direction={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      sx={{ margin: '24px 16px' }}
      className="card-header-container"
    >
      <CardHeaderTitle />
      <Typography variant="h3" sx={{ marginTop: '16px' }} className="card-header-amount-due">
        {numberHelper.formatMoney(amountDue)}
      </Typography>
      {hasPaymentInTransit && paymentInTransitDetails && paymentInTransitDetails?.length > 0 && (
        <Stack direction={'row'} gap={'4px'} alignItems={'center'} sx={{ marginTop: '16px' }}>
          <Icon iconName="circle-check-regular" className="paid-icon" sx={{ fontSize: '1.2Rem', color: '#4F8C24' }} />
          <Typography variant="b1Regular" className="pit-payment-info">
            You paid {numberHelper.formatMoney(Number(paymentInTransitDetails[0].pitAmount))} on{' '}
            {formatDateToMMDDYYYY(paymentInTransitDetails[0].pitDate)}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
